import CityLandingPage from './page';

const jundiaiData = {
  cityName: 'Jundiaí',
  state: 'SP',
  slug: 'palestra-silenciosa-jundiai',
  coordinates: { lat: -23.1865, lng: -46.8845 },
  phone: '(11) 91777-6227',
  localKeywords: [
    'palestra silenciosa jundiai',
    'silent conference jundiai sp',
    'aluguel fones sem fio jundiai',
    'eventos corporativos jundiai',
    'tradução simultânea jundiai',
    'festa silenciosa jundiai',
  ],
  heroTitle: 'palestra silenciosa jundiaí',
  heroSubtitle: 'Tecnologia de áudio sem fio premium para eventos corporativos em Jundiaí. Polo logístico estratégico e hub de distribuição com suporte técnico especializado para eventos empresariais.',
  localStats: { clients: '45+', satisfaction: '98%' },
  localTestimonials: [],
  localFAQs: [
    { question: 'Vocês atendem toda a região de Jundiaí?', answer: 'Sim! Atendemos Jundiaí, Itupeva, Louveira, Várzea Paulista, Campo Limpo Paulista e região. Cobertura ágil com equipe dedicada para o eixo Jundiaí-Campinas.' },
    { question: 'Qual o prazo de antecedência para Jundiaí?', answer: 'Recomendamos 2 semanas para eventos padrão e 1 mês para grandes eventos corporativos. Nossa proximidade com a região permite atender demandas urgentes com rapidez.' },
    { question: 'Vocês atendem centros de distribuição e empresas de logística em Jundiaí?', answer: 'Sim, Jundiaí é um dos maiores polos logísticos do Brasil e temos ampla experiência com esse setor. Sabemos adaptar a tecnologia para ambientes operacionais, mantendo a qualidade do áudio em qualquer cenário.' },
    { question: 'Quantos fones estão disponíveis para Jundiaí?', answer: 'De treinamentos corporativos compactos (25 fones) a grandes encontros empresariais (250+ fones). Equipamentos premium com áudio cristalino e bateria de longa duração.' },
    { question: 'A transmissão cobre bem os grandes galpões logísticos de Jundiaí?', answer: 'Sim! Nosso sistema tem alcance de 100m sem obstáculos e funciona muito bem em grandes áreas. Os fones têm excelente isolamento, perfeitos para treinamentos em ambientes operacionais.' },
  ],
  seoTitle: 'Jundiaí Palestra Silenciosa | Aluguel Fones Sem Fio SP | STIB',
  seoDescription: 'Palestra silenciosa Jundiaí: aluguel de fones sem fio para eventos corporativos e treinamentos em polos logísticos. Hub de distribuição com tecnologia premium. Solicite orçamento!',
  relatedCities: [
    { name: 'São Paulo (Capital)', slug: '/sao-paulo', region: 'Capital' },
    { name: 'Campinas', slug: '/campinas', region: 'Região Metropolitana' },
    { name: 'Barueri / Alphaville', slug: '/barueri', region: 'Grande SP Oeste' },
    { name: 'São José dos Campos', slug: '/sao-jose-dos-campos', region: 'Vale do Paraíba' },
    { name: 'Ribeirão Preto', slug: '/ribeirao-preto', region: 'Interior Norte' },
    { name: 'Santos', slug: '/santos', region: 'Baixada Santista' },
    { name: 'Guarulhos', slug: '/guarulhos', region: 'Grande SP Leste' },
    { name: 'São Bernardo do Campo', slug: '/sao-bernardo-do-campo', region: 'ABCD Paulista' },
  ],
};

export default function JundiaiLandingPage() {
  return <CityLandingPage cityData={jundiaiData} />;
}